<template>
	<ui-card>
		<ui-title class="has-text-white mb-4">Löpande Kontroller</ui-title>
		<ui-tabs v-model="activeTab" :tabs="tabs"/>
		<ui-tab>
			<ui-table
				v-if="activeTab === 'coming'"
				service="roundPlanning"
				method="getRoundPlannings"
				rowHoverEffect
				:headers="headers"
				:queryParams="getQueryParams"
				@rowClick="startRound"
				:activeTab="activeTab"
			>
				<template #item.actions="{ item }">
					<span
						:class="[{'Dashboard-PlanningAction--disabled': !item.activeHistory || readonly }]"
						style="cursor: pointer;" @click="sendMail(item)"
					>
						<i class="fas fa-envelope"></i>
					</span>
					<span
						:class="['ml-4', { 'Dashboard-PlanningAction--disabled': !item.activeHistory || readonly }]"
						style="cursor: pointer;"
						@click="startRound(item)"
					>
						<i class="fas fa-play"></i>
					</span>
				</template>
			</ui-table>

			<ui-table v-if="activeTab === 'done'"
				service="roundHistory"
				method="getCompletedRoundHistories"
				:headers="headersHistory"
				:queryParams="getCompletedRoundQueryParams"
				row-tint="227 245 224"
				@rowClick="startRound"
				rowHoverEffect
				:activeTab="activeTab"
			/>

			<ui-table v-if="activeTab === 'uncompleted'"
				service="roundHistory"
				method="getUnCompletedRoundHistories"
				:headers="headersHistory"
				:queryParams="getUnCompletedRoundQueryParams"
				row-tint="245 224 224"
				@rowClick="startRound"
				rowHoverEffect
				:activeTab="activeTab"
			/>
		</ui-tab>


		<DashboardModalMail v-if="showMailSendModal"
			type="round"
			:item="mailItem"
			@cancel="showMailSendModal = false; mailItem = null;"/>
	</ui-card>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardModalMail from './modal/mail';
import moment from 'moment';

export default {
	components: {
		DashboardModalMail
	},

	props: {
		readonly: {
			type: Boolean,
			default: false
		},
		customerId: {
			type: String,
			default: ''
		}
	},

	data: vm => ({
		headers: [{
			text: 'Namn',
			value: 'name'
		},{
			text: 'Utföres',
			value: 'lastRun',
			sortable: true,
			transformFromParentObject: val => vm.$utils.date.getLastRunFormatted(val)
		}, {
			align: 'right',
			text: '',
			value: 'actions'
		}],

		headersHistory: [{
			text: 'Namn',
			value: 'name'
		}, {
			text: 'Utförd',
			value: 'done',
			sortable: true,
			transform: val => moment(val).format('YYYY-MM-DD')
		}],

		tabs: [{
			key: 'coming',
			label: 'Kommande',
			icon: 'fa-sticky-note'
		}, {
			key: 'done',
			label: 'Utförda',
			icon: 'fa-check'
		}, {
			key: 'uncompleted',
			label: 'Ej kompletta',
			icon: 'fa-check'
		}],

		activeTab: 'coming',

		showMailSendModal: false,
		mailItem: null
	}),

	computed: {
		...mapGetters('user', ['getActiveCustomer', 'getActiveBuilding']),

		getQueryParams() {
			return {
				customerId: this.customerId,
				buildingId: this.getActiveBuilding.id
			};
		},

		getCompletedRoundQueryParams() {
			return {
				customerId: this.customerId,
				buildingId: this.getActiveBuilding.id,
				done: true,
				excludeExpired: true
			};
		},

		getUnCompletedRoundQueryParams() {
			return {
				customerId: this.customerId,
				buildingId: this.getActiveBuilding.id,
				done: true
			};
		}
	},

	methods: {
		sendMail(item) {
			this.mailItem = { ...item };
			this.showMailSendModal = true;
		},

		startRound(round) {
			if (this.readonly || (!round.activeHistory && !round.done))  return;

			if (!round.done) {
				this.$router.push({
					name: 'StartRoundView',
					params: {
						roundId: round.id
					}
				});
			} else {
				this.$router.push({
					name: 'FinishedRoundView',
					params: {
						roundId: round.id
					}
				});
			}
		}
	}
};
</script>

<style lang="scss">
@import '@/assets/colors.scss';

.Dashboard-PlanningAction--disabled {
	pointer-events: none;

	i {
		color: $light-grey;
	}
}
</style>
